import { SVGProps } from 'react'

const SvgLightbulb = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' {...props}>
    <path d='m855-615-55-25 55-25 25-55 25 55 55 25-55 25-25 55-25-55ZM722-802l-82-38 82-38 38-82 38 82 82 38-82 38-38 82-38-82ZM360-80q-33 0-56.5-23.5T280-160h160q0 33-23.5 56.5T360-80ZM240-200q-17 0-28.5-11.5T200-240q0-17 11.5-28.5T240-280h240q17 0 28.5 11.5T520-240q0 17-11.5 28.5T480-200H240Zm-30-120q-69-41-109.5-110T60-580q0-125 87.5-212.5T360-880q125 0 212.5 87.5T660-580q0 81-40.5 150T510-320H210Z' />
  </svg>
)

export default SvgLightbulb
